export default __webpack_public_path__ + "static/carlos-reynosa-bacf7f90ab2b2a07035969b8e9968ad6.jpeg";